import { EcommerceProduct, SkyBoxEnum, SkyBoxEnumType } from '@sky/util-models';

export function GASkyBoxName(applianceCode: SkyBoxEnumType) {
  return (
    (applianceCode === SkyBoxEnum.SkyQ && 'sky-q') ||
    (applianceCode === SkyBoxEnum.Virtual && 'devices-only')
  );
}

export function GAMultiplanApliance(ecommerceProducts: EcommerceProduct[]) {
  return ecommerceProducts
    .map(
      (device: EcommerceProduct, i: number) =>
        `${i + 1}:${device.title} £${device.price}`
    )
    .join('|');
}
